const trustedFormConfig = {
  mappedAdmiralQuestionId: '79475aaf-a16f-11ed-b8e1-06faf8b4041b',
  questionText: 'Trusted Form',
};

export default trustedFormConfig;
